import { ReactNode } from 'react';
import { Typography } from '../../../../../Typography';

interface FooterLabelOptionProps {
  children: ReactNode;
}
export const FooterLabelOption = ({ children }: FooterLabelOptionProps) => {
  return <Typography className="!text-h5 !text-secondary-900">{children}</Typography>;
};
